import { useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import ICurrentUser from "../../entities/helper/ICurrentUser";
import { usePromiseEffect } from "../../helpers/promiseEffect";
import { cognitoUserInfo, cognitoUserToken } from "../../helpers/userHelper";
import Planes from "./components/homeAuditoria/Planes";
import Programas from "./components/homeAuditoria/Programas";
interface IAuditHomeProps {
  isHistorico?: boolean;
  is_test?: boolean;
  itemsTest?: any[];
}
const AuditHome = ({ isHistorico, is_test, itemsTest }: IAuditHomeProps) => {
  const userInfo = cognitoUserToken();

  const [token, setToken] = useState("");
  const [currentUser, setCurrentUser] = useState<ICurrentUser>();
  const [isLoading, setIsLoading] = useState(true);

  usePromiseEffect(async () => {
    let token = await userInfo;
    setToken(token);
    let currUser = await cognitoUserInfo();
    console.log(currentUser)
    setCurrentUser(currUser);
    setIsLoading(false);
  }, []);
  return isLoading ? (
    <div>-</div>
  ) : (
    <div className="row">
      <div className="col-12">
        <div className="rounded bg-white p-2 shadow">
          <div className="container-fluid mb-4">
            <h1 className="titPrincipal colorTit">Auditoría</h1>
            <Tabs defaultActiveKey="profile" id="uncontrolled-tab-example" className="mb-3">
              <Tab
                eventKey="home"
                title={
                  <span>
                    Programas de Auditoría <i className="bi bi-eye" />{" "}
                  </span>
                }>
                <Programas token={token} isHistorico={isHistorico || false} items={is_test ? itemsTest : undefined} />
              </Tab>
              <Tab
                eventKey="profile"
                title={
                  <span>
                    Planes de Auditoría <i className="bi bi-eye" />{" "}
                  </span>
                }>
                <Planes token={token} isHistorico={isHistorico || false} />
              </Tab>
            </Tabs>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AuditHome;
